// extracted by mini-css-extract-plugin
export default {"main":"_725aa9c550","tit":"_486ea05f3f","maintitle":"_39e3a8da85","ylw":"df87d2b932","white":"_80e651bc06","mv_title":"_76e6b60b72","mv_nc":"d9f1d3c011","mv_in":"_0200860a96"};